import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 60000,
});

export const apiGet = (path, config) => api.get(path, config).then((r) => r.data);
export const apiPost = (path, body, config) => api.post(path, body, config).then((r) => r.data);
export const apiPatch = (path, body, config) => api.patch(path, body, config).then((r) => r.data);
export const apiPut = (path, body, config) => api.put(path, body, config).then((r) => r.data);
export const apiDelete = (path, config) => api.delete(path, config).then((r) => r.data);

export const formatLKR = (value, opts = {}) => {
  if (value === null || value === undefined || isNaN(value)) return "—";
  const { compact = false, decimals = 2 } = opts;
  if (compact) {
    const abs = Math.abs(value);
    if (abs >= 1e9) return `Rs. ${(value / 1e9).toFixed(2)}B`;
    if (abs >= 1e6) return `Rs. ${(value / 1e6).toFixed(2)}M`;
    if (abs >= 1e3) return `Rs. ${(value / 1e3).toFixed(2)}K`;
  }
  return `Rs. ${Number(value).toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
};

export const formatPct = (value, decimals = 2) => {
  if (value === null || value === undefined || isNaN(value)) return "—";
  const sign = value > 0 ? "+" : "";
  return `${sign}${Number(value).toFixed(decimals)}%`;
};

export const formatNumber = (value, opts = 0) => {
  if (value === null || value === undefined || isNaN(value)) return "—";
  // Backwards compat: opts may be a number (decimals) or an object { decimals?, compact? }
  const config = typeof opts === "number" ? { decimals: opts } : (opts || {});
  const decimals = Number.isFinite(config.decimals) ? config.decimals : 0;
  const num = Number(value);
  if (config.compact) {
    const abs = Math.abs(num);
    if (abs >= 1_000_000_000) return `${(num / 1_000_000_000).toFixed(decimals || 1)}B`;
    if (abs >= 1_000_000) return `${(num / 1_000_000).toFixed(decimals || 1)}M`;
    if (abs >= 1_000) return `${(num / 1_000).toFixed(decimals || 1)}K`;
  }
  return num.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString(undefined, { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
};

/**
 * Format a date in Sri Lanka time (Asia/Colombo) with a "SLT" suffix.
 * Use this for any time that represents Colombo Stock Exchange business
 * hours or Sri Lanka-anchored scheduled jobs (price refresh, market close,
 * announcement deadlines, etc.) so the value is correct no matter where
 * the viewer's browser is set.
 *
 * Example output: "Apr 30, 2026, 05:30 PM SLT"
 */
export const formatDateTimeSLT = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-GB", {
    timeZone: "Asia/Colombo",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }) + " SLT";
};
